import {
  $,
  React,
  Axios,
  validator,
  ImageUploader,
  Modal,
  dt,
} from "../../../Headers";

export default function BookCarousel() {
  const [imagesData, setImagesData] = React.useState([]);
  const [formAction, setFormAction] = React.useState("ADD");
  const [id, setId] = React.useState("");
  const [picture, setPicture] = React.useState("");

  const [modelIsOpenForSubmit, setModelIsOpenForSubmit] = React.useState(false);
  const [modelIsOpenForInactive, setModelIsOpenForInactive] =
    React.useState(false);
  const [modelIsOpenForResponse, setModelIsOpenForResponse] =
    React.useState(false);

  const [response, setResponse] = React.useState("");
  const [errors, setErrors] = React.useState({});
  const [server, setServer] = React.useState("");

  // Refs
  const url = React.useRef();

  // --------------------------------------------------------
  // VALIDATION
  // --------------------------------------------------------
  const handleValidation = () => {
    let err = {};
    let valid = true;

    const isBlank = (v) => validator.isEmpty(v.trim());

    if (isBlank(url.current.value)) {
      valid = false;
      err.url = "Url is required";
    }

    setErrors(err);
    return valid;
  };

  // --------------------------------------------------------
  // Image Upload Handler
  // --------------------------------------------------------
  const ondrop = (pictures) => {
    setPicture(pictures);
  };

  // --------------------------------------------------------
  // Edit Form Data
  // --------------------------------------------------------
  const Edit = (data) => {
    setFormAction("EDIT");
    setId(data.id);

    url.current.value = data.url;
  };

  // --------------------------------------------------------
  // Reset Form
  // --------------------------------------------------------
  const ResetForm = () => {
    setFormAction("ADD");
    setPicture("");

    url.current.value = "";
  };

  // --------------------------------------------------------
  // Submit
  // --------------------------------------------------------
  const Submit = (event) => {
    event.preventDefault();
    setModelIsOpenForSubmit(false);

    const fd = new FormData();

    fd.append("url", url.current.value);
    fd.append("images", picture[0]);

    if (formAction === "ADD") {
      Axios.post(
        `//${server}/controller/AddImagesCarouselController.php`,
        fd
      ).then((res) => {
        setResponse(res.data.value?.Msg || res.data.Msg);
        setModelIsOpenForResponse(true);
      });
    } else {
      fd.append("id", id);

      Axios.post(
        `//${server}/controller/EditImagesCarouselController.php`,
        fd
      ).then((res) => {
        setResponse(res.data.Msg);
        setModelIsOpenForResponse(true);
      });

      setFormAction("ADD");
    }
  };

  // --------------------------------------------------------
  // Inactive
  // --------------------------------------------------------
  const InactiveArticle = () => {
    setModelIsOpenForInactive(false);

    Axios.post(`//${server}/controller/InactiveImagesCarouselController.php`, {
      id: id,
    }).then((res) => {
      setResponse(res.data.Msg);
      setModelIsOpenForResponse(true);
    });
  };

  // --------------------------------------------------------
  // Open Modal Handler
  // --------------------------------------------------------
  const ToOpenModel = (event, button, id) => {
    event.preventDefault();

    if (button === "submit") {
      if (handleValidation()) {
        setModelIsOpenForSubmit(true);
      }
    } else if (button === "inactive") {
      setModelIsOpenForInactive(true);
      setId(id);
    }
  };

  // --------------------------------------------------------
  // COMPONENT DID MOUNT (Data Load)
  // --------------------------------------------------------
  React.useEffect(() => {
    const srv = window.$name;
    setServer(srv);

    Axios.post(`//${srv}/controller/GetImagesCarouselController.php`, {}).then(
      (res) => {
        setImagesData(res.data);

        setTimeout(() => {
          $("#table").DataTable({
            responsive: true,
            fnRowCallback: (nRow, aData, iDisplayIndex, iDisplayIndexFull) => {
              $("td:first", nRow).html(iDisplayIndexFull + 1);
            },
            columnDefs: [
              { responsivePriority: 1, targets: -1 },
              { responsivePriority: 2, targets: 1 },
              { responsivePriority: 3, targets: 0 },
            ],
          });
        }, 200);
      }
    );
  }, []);

  // --------------------------------------------------------
  // RENDER JSX
  // --------------------------------------------------------
  return (
    <>
      {/* FORM SECTION */}
      <section class="content ">
        <div class="container d-flex justify-content-center" id="Journal_form">
          <div className="col-6" id="ss-sad-login-007">
            <div id="ss-sad-login-008" class="card-header text-left">
              <div class="ss-sad-login-009" style={{ textAlign: "center" }}>
                Create Book Carousel
              </div>
            </div>

            <div className="container">
              <form
                onSubmit={(e) => ToOpenModel(e, "submit", "")}
                onReset={ResetForm}
              >
                <center>
                  <div className="form">
                    {/* Book Name */}
                    <div className="row">
                      <div className="col-md-12">
                        <input
                          ref={url}
                          id="url"
                          className="form-control"
                          type="url"
                          placeholder="url"
                        />
                        <span style={{ color: "red" }}>{errors.url}</span>
                      </div>
                    </div>

                    {/* Image Upload */}
                    <ImageUploader
                      withIcon={false}
                      withPreview={true}
                      buttonText="Upload Images"
                      onChange={ondrop}
                      imgExtension={[".jpg", ".png"]}
                      maxFileSize={5000000}
                      label="Max file size 5mb, accepted: jpg|png"
                    />

                    {/* Buttons */}
                    <div className="row d-flex justify-content-center">
                      <button
                        type="submit"
                        id="ss-sad-login-014"
                        className="btn btn-block col-3"
                      >
                        Submit
                      </button>
                      <button
                        type="reset"
                        id="reset"
                        className="btn btn-block col-3"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </center>
              </form>
            </div>
          </div>
        </div>

        {/* TABLE SECTION */}
        <div className="container-fluid mt-3">
          <table id="table" className="display hover" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>#</th>
                <th>Url</th>
                <th>Image</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {imagesData.map((data) => (
                <tr key={data.id}>
                  <td></td>
                  <td>{data.url}</td>
                  <td>
                    <img
                      src={window.$file +"BookCarousel/" + data.image}
                      width={60}
                      height={60}
                    ></img>
                  </td>

                  <td>
                    <div className="btn-group">
                      <a href="#Journal_form" className="m-2">
                        <button
                          type="button"
                          className="btn-lg responsive_btn"
                          title="Edit"
                          onClick={() => Edit(data)}
                        >
                          <i class="far fa-edit"></i>
                        </button>
                      </a>

                      <button
                        type="button"
                        className="btn-lg responsive_btn m-2"
                        title="Inactive"
                        onClick={(e) => ToOpenModel(e, "inactive", data.id)}
                      >
                        <i class="far fa-eye-slash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Submit Modal */}
      <Modal
        isOpen={modelIsOpenForSubmit}
        className="popup-modal-content-subscribe"
        overlayClassName="popup-modal"
        onRequestClose={() => setModelIsOpenForSubmit(false)}
      >
        <span
          className="closed"
          type="button"
          style={{
            fontSize: "32px",
            position: "absolute",
            zIndex: "1",
            right: "3%",
            height: "6.7vh",
            lineHeight: "6.7vh",
          }}
          onClick={() => setModelIsOpenForSubmit(false)}
        >
          &times;
        </span>

        <div
          className="card-header"
          id="ss-uad-article-10"
          style={{ justifyContent: "flex-start", paddingLeft: "5%" }}
        >
          <span id="ss-uad-article-12">Alert</span>
        </div>

        <div className="card-body">
          <p id="assign-popup-box-msg">Do you want to submit this record?</p>

          <div
            className="row"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <button
              id="ss-uad-article-09"
              style={{
                height: "50px",
                lineHeight: "initial",
                padding: "initial",
                width: "110px",
              }}
              className="btn btn-primary mr-2 col-5"
              type="submit"
              onClick={Submit}
            >
              <i className="fas fa-check" style={{ fontSize: "25px" }}></i>
            </button>

            <button
              id="ss-uad-article-08"
              style={{
                height: "50px",
                lineHeight: "initial",
                padding: "initial",
                width: "110px",
              }}
              className="btn btn-danger col-5"
              onClick={() => setModelIsOpenForSubmit(false)}
            >
              <i className="fas fa-times" style={{ fontSize: "29px" }}></i>
            </button>
          </div>
        </div>
      </Modal>

      {/* Inactive Modal */}
      <Modal
        isOpen={modelIsOpenForInactive}
        className="popup-modal-content-subscribe"
        overlayClassName="popup-modal"
        onRequestClose={() => setModelIsOpenForInactive(false)}
      >
        <span
          className="closed"
          type="button"
          style={{
            fontSize: "32px",
            position: "absolute",
            zIndex: "1",
            right: "3%",
            height: "6.7vh",
            lineHeight: "6.7vh",
          }}
          onClick={() => setModelIsOpenForInactive(false)}
        >
          &times;
        </span>

        <div
          className="card-header"
          id="ss-uad-article-10"
          style={{ justifyContent: "flex-start", paddingLeft: "5%" }}
        >
          <span id="ss-uad-article-12">Alert</span>
        </div>

        <div className="card-body">
          <p id="assign-popup-box-msg">Do you want to inactive this record?</p>

          <div
            className="row"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <button
              id="ss-uad-article-09"
              style={{
                height: "50px",
                lineHeight: "initial",
                padding: "initial",
                width: "110px",
              }}
              className="btn btn-primary mr-2 col-5"
              type="submit"
              onClick={InactiveArticle}
            >
              <i className="fas fa-check" style={{ fontSize: "25px" }}></i>
            </button>

            <button
              id="ss-uad-article-08"
              style={{
                height: "50px",
                lineHeight: "initial",
                padding: "initial",
                width: "110px",
              }}
              className="btn btn-danger col-5"
              onClick={() => setModelIsOpenForInactive(false)}
            >
              <i className="fas fa-times" style={{ fontSize: "29px" }}></i>
            </button>
          </div>
        </div>
      </Modal>

      {/* Response */}
      <Modal
        isOpen={modelIsOpenForResponse}
        className="popup-modal-content-success"
        overlayClassName="popup-modal"
        onRequestClose={() => window.location.reload()}
      >
        <div className="row" style={{ height: "100%", margin: "0px" }}>
          <div className="col-9" style={{ paddingTop: "6px" }}>
            <p id="popup-title">Remark</p>
            <p id="popup-content">{response}</p>
          </div>

          <div
            className="col-3"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <button
              id="ss-uad-article-09"
              style={{
                height: "50px",
                lineHeight: "initial",
                padding: "initial",
                width: "110px",
              }}
              className="btn btn-primary"
              onClick={() => window.location.reload()}
            >
              <i className="fas fa-check" style={{ fontSize: "29px" }}></i>
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
